// De schakelaar van de trendlaag (sessie 2–3 van de trendlaag-bouw). Aan met
// ?trendlaag=1 (uit met ?trendlaag=0); de keuze blijft in deze browser, zodat
// ook de chat op een andere tab hem ziet. Zonder keuze geldt de standaard hieronder.

const SLEUTEL = "summa-trendlaag";

// De standaard als er niets gekozen is. De app zet hem zodra /api/mij binnen is
// en vóór er één scherm of aanvraag staat: aan voor wie is ingelogd en geen
// beheerder is (de bundels van hun propositie staan klaar), uit voor beheer (dat
// houdt ?trendlaag=1; ICT heeft bundels die alleen beheer ziet) en voor wie niet
// is ingelogd.
let standaardAan = false;

export function zetTrendlaagStandaard(aan: boolean): void {
  standaardAan = aan;
}

export function trendlaagAan(): boolean {
  try {
    const p = new URLSearchParams(window.location.search).get("trendlaag");
    if (p === "1" || p === "0") localStorage.setItem(SLEUTEL, p);
    const bewaard = localStorage.getItem(SLEUTEL);
    return bewaard === null ? standaardAan : bewaard === "1";
  } catch {
    return standaardAan;
  }
}
